import PropTypes from 'prop-types';
import React from 'react';

const EchoPage = ({ echo1, echo2, echo3 }) => (
    <div className="page">
        <span>Echographie</span>
        <div>
            <span>1ère échographie</span>
            <span>{`Du ${echo1.min} (11 SA)`}</span>
            <span>{`Au ${echo1.max} (13 SA +6)`}</span>
            <span>{`=> ${echo1.best} (12 SA)`}</span>
        </div>

        <div>
            <span>2ème échographie</span>
            <span>{`Du ${echo2.min} (20 SA)`}</span>
            <span>{`Au ${echo2.max} (25 SA)`}</span>
            <span>{`=> ${echo2.best} (22 SA)`}</span>
        </div>

        <div>
            <span>3ème échographie</span>
            <span>{`Du ${echo3.min} (30 SA)`}</span>
            <span>{`Au ${echo3.max} (35 SA)`}</span>
            <span>{`=> ${echo3.best} (32 SA)`}</span>
        </div>
    </div>
);

const minMaxProp = PropTypes.shape({
    min: PropTypes.string.isRequired,
    max: PropTypes.string.isRequired,
    best: PropTypes.string.isRequired,
});
EchoPage.propTypes = {
    echo1: minMaxProp.isRequired,
    echo2: minMaxProp.isRequired,
    echo3: minMaxProp.isRequired,
};
export default EchoPage;
